import React, { useCallback, useEffect } from 'react';
import { FacebookIcon, InstagramIcon, MailIcon } from 'lucide-react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { BonusSection } from './components/BonusSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FaqSection } from './components/FaqSection';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { warmConnections, runWhenIdle } from './utils/preload';
import { MAIN_MOCKUP } from './data/content';
const CHECKOUT_URL = 'https://www.saleunbuenmate.com/cart/49535583551703:1';
export function App() {
  useEffect(() => {
    // Prioriza el primer render: primero se calientan las conexiones,
    // el pixel se carga recién cuando el navegador está libre.
    warmConnections(CHECKOUT_URL, MAIN_MOCKUP);
    runWhenIdle(initMetaPixel);
  }, []);
  const handleBuy = useCallback(() => {
    trackPixelEvent('AddToCart', {
      content_name: 'El Secreto del Mate Perfecto',
      content_type: 'product',
      value: 490,
      currency: 'ARS'
    });
    window.location.assign(CHECKOUT_URL);
  }, []);
  return <div className="min-h-full w-full bg-[#E4EFDF]" data-id="element-0" data-mp="5osn3wyp084">
      <main className="relative mx-auto w-full max-w-phone bg-night font-sans text-ivory" data-id="element-1" data-mp="5gg5d4r3wxg">
        <Hero data-id="element-2" data-mp="2zmemk4sx3e5x" />
        <PainSection data-id="element-3" data-mp="2zmwggus3xgao" />
        <BenefitsSection data-id="element-4" data-mp="2znfy0adui2o6" />
        <OfferSection onBuy={handleBuy} data-id="element-5" data-mp="33m5bs42spm8c" />
        <BonusSection data-id="element-6" data-mp="33mym1f0yqtv8" />
        <ReviewsSection data-id="element-7" data-mp="33oi1x4ipj2wh" />
        <FaqSection data-id="element-8" data-mp="38l8iru2c62iy" />

        <footer className="bg-botanic px-5 py-10 text-center" data-id="element-9" data-mp="38kqafz2efxuo">
          <p className="font-display text-[15px] text-gold" data-id="element-10" data-mp="3dkl42adk71jf">
            🧉 El Secreto del Mate Perfecto
          </p>
          <nav aria-label="Redes y contacto" className="mt-4 flex items-center justify-center gap-4" data-id="element-11" data-mp="nwc23tmizxws">
            <a href="https://www.facebook.com/profile.php?id=61591809817612" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-200 hover:border-gold hover:bg-gold/10" data-id="element-12" data-mp="stuczpk3sn7f">
              <FacebookIcon aria-hidden="true" className="h-5 w-5" data-id="element-13" data-mp="d3mmvivk99nu" />
            </a>
            <a href="https://www.instagram.com/saleunbuenmate_oficial/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-200 hover:border-gold hover:bg-gold/10" data-id="element-14" data-mp="85bbv4tj4t41">
              <InstagramIcon aria-hidden="true" className="h-5 w-5" data-id="element-15" data-mp="3qbfud0nzi3pc" />
            </a>
            <a href="mailto:saleunbuenmate@gmail.com" aria-label="Escribinos por correo" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-200 hover:border-gold hover:bg-gold/10" data-id="element-16" data-mp="3ljxw4kdcih82">
              <MailIcon aria-hidden="true" className="h-5 w-5" data-id="element-17" data-mp="2stpm5fsyr34k" />
            </a>
          </nav>

          <a href="mailto:saleunbuenmate@gmail.com" className="mt-3 inline-block font-sans text-[13px] text-ivory/60 underline decoration-gold/40 underline-offset-4" data-id="element-18" data-mp="18cgfzx81o9n8">
            saleunbuenmate@gmail.com
          </a>

          <p className="mt-4 font-sans text-[12px] leading-relaxed text-ivory/40" data-id="element-19" data-mp="ydqw5ywl8f4c">
            Contenido educativo e informativo. No reemplaza el consejo de un
            profesional de la salud.
          </p>
        </footer>
      </main>
    </div>;
}